/* eslint-disable import/prefer-default-export */
// Map ReviewDocumentsManager fields to restriction-like format
const REVIEW_DOCUMENT_MAPPING = [
  {
    key: 'oc',
    requiresField: 'requiresOc',
    stateField: 'ocReviewState',
    restrictionKey: 'review_oc',
    restrictionLabel: 'Subir OC de la factura',
    description: 'Subir orden de compra vigente',
  },
  {
    key: 'hes',
    requiresField: 'requiresHes',
    stateField: 'hesReviewState',
    restrictionKey: 'review_hes',
    restrictionLabel: 'Subir HES de la factura',
    description: 'Subir HES (Hoja de Entrada de Servicio)',
  },
  {
    key: 'paymentStatus',
    requiresField: 'requiresPaymentStatus',
    stateField: 'paymentStatusReviewState',
    restrictionKey: 'review_payment_status',
    restrictionLabel: 'Subir comprobante de pago de la factura',
    description: 'Subir comprobante de pago del deudor',
  },
  {
    key: 'portalScreenshot',
    requiresField: 'requiresPortalScreenshot',
    stateField: 'portalScreenshotReviewState',
    restrictionKey: 'review_portal_screenshot',
    restrictionLabel: 'Subir captura del portal del deudor',
    description: 'Subir captura del portal del deudor',
  },
  {
    key: 'receptionAcknowledgment',
    requiresField: 'hasReceptionAcknowledgment',
    stateField: 'receptionAcknowledgmentReviewState',
    restrictionKey: 'review_reception_acknowledgment',
    restrictionLabel: 'Acuse de recibo',
    description: 'Subir acuse de recibo firmado',
  },
];

const STATUS_LABELS = {
  PENDINGREVIEW: 'Pendiente',
  REJECTED: 'Rechazado',
  ACCEPTED: 'Aprobado',
  NOTREQUIRED: 'No requerido',
};

export const STATE_MAPPING = {
  PENDINGREVIEW: 'PENDINGREVIEW',
  REJECTED: 'REJECTED',
  ACCEPTED: 'ACCEPTED',
  NOTREQUIRED: 'NOTREQUIRED',
};

const normalizeState = (state) => {
  if (!state) return null;
  const normalized = state.toString().replace(/_/g, '').toUpperCase();
  return STATE_MAPPING[normalized] || null;
};

// eslint-disable-next-line import/prefer-default-export
export const transformReviewDocumentsToRestrictions = (reviewDocumentsManager) => {
  if (!reviewDocumentsManager) return [];

  return REVIEW_DOCUMENT_MAPPING
    .filter((config) => reviewDocumentsManager[config.requiresField])
    .map((config) => {
      const state = normalizeState(reviewDocumentsManager[config.stateField]);
      return {
        id: `rdm_${reviewDocumentsManager.id}_${config.key}`,
        restriction: config.restrictionKey,
        restrictionLabel: config.restrictionLabel,
        description: config.description,
        status: state,
        statusLabel: STATUS_LABELS[state],
        restrictionType: 'Operations',
      };
    });
};

export const transformOnlyPendingReviewDocumentsToRestrictions = (reviewDocumentsManager) => {
  const allRestrictions = transformReviewDocumentsToRestrictions(reviewDocumentsManager);
  return allRestrictions.filter((restriction) => [
    STATE_MAPPING.PENDINGREVIEW,
    STATE_MAPPING.REJECTED].includes(restriction.status));
};
